module.exports = __webpack_public_path__ + "static/media/cscc-cover.27992892.jpg";